<!-- <app-antecedentes-paciente >
</app-antecedentes-paciente> -->

<app-antecedentes-medicos></app-antecedentes-medicos>